import React, { useMemo } from "react";
import moment from "moment";
import { formatPrice } from "@/utils/utils";
import useScreenDetector from "@/hooks/useScreenDetector";
import ViewVehicles from "@/components/ViewVehicles";
import OriginToDesination from "../../DealerDashboard/components/OriginToDestination/OriginToDesination.jsx";

export const useQuotesTableColumns = ({ isCompleted }) => {
  const { isMobile } = useScreenDetector();

  return useMemo(
    () => [
      {
        title: "Shipment Id",
        dataIndex: "id",
        minWidth: isMobile ? 80 : 146,
        render: text => {
          return <span className="span-click">{text.split("-")[0].toUpperCase()}</span>;
        },
      },
      {
        title: "Created at",
        dataIndex: "creationTime",
        minWidth: 146,
        render: text => {
          return <span className="span-click">{moment.utc(text).locale("en").local().format("MMM Do, YYYY")}</span>;
        },
      },
      {
        title: "Dealer Name",
        dataIndex: "dealerName",
        minWidth: isMobile ? 80 : 160,
        render: text => {
          return <span className="span-click">{text || ""}</span>;
        },
      },
      {
        title: "Pickup/Dropoff Location",
        dataIndex: "location",
        minWidth: isCompleted ? 140 : 180,
        render: (_text, record) => {
          return <OriginToDesination record={record} />;
        },
      },
      {
        title: "Dealer Price",
        dataIndex: "totalDealerPrice",
        minWidth: 146,
        render: text => {
          return <span className="span-click">{formatPrice(text && text !== "-" ? text : "0.00")}</span>;
        },
      },
      {
        title: "Vehicles",
        minWidth: 170,
        dataIndex: "vehicles",
        render: (_text, record) => {
          return <ViewVehicles vehicles={record?.vehicles || []} />;
        },
      },
    ],
    [isMobile, isCompleted],
  );
};

export default useQuotesTableColumns;
